import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";

import SetAdvisor from "data/advisor/actions";
import { GetAdvisor } from "data/libs/advisor";
import OauthCallback from "data/libs/oauth";

import { useBooleanState } from "hooks";
import Modal from "components/Modal";

function OauthHelper() {
  const {
    location: { search },
  } = useHistory();
  const [isModalOpen, , close] = useBooleanState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    OauthCallback(search)
      .then(() => {
        GetAdvisor().then((advisor) => {
          dispatch(SetAdvisor(advisor));
        });
      })
      .catch((e) => {
        setError(e);
      });
  }, [search, dispatch]);

  if (error) {
    return (
      <Modal size="small" isModalOpen={isModalOpen}>
        <Modal.Header onClose={close}>Error</Modal.Header>
        <Modal.Body>
          {error?.message || "Error processing the oauth request."}
        </Modal.Body>
      </Modal>
    );
  }

  return null;
}

export function HublyOauthLinkHandler(props) {
  return (
    <Switch>
      <Route
        exact
        path={["/oauth/callback"]}
        render={() => {
          return <OauthHelper {...props} />;
        }}
      />
    </Switch>
  );
}

export default HublyOauthLinkHandler;
